import { Injectable } from '@angular/core';
import { AziendaService } from '../azienda/azienda.service';
import { Utente, UtenteService } from '../utente/utente.service';
import { WebService } from '../web/web.service';

@Injectable({
  providedIn: 'root',
})
export class BucketWebService {
  private _idAzienda: string | undefined = undefined;

  public infoUtente: Utente | undefined;
  constructor(
    private readonly _webService: WebService,
    private readonly _aziendaService: AziendaService,
    private readonly _infoUtente: UtenteService,
  ) {
    this._aziendaService.aziendaCorrente.subscribe((azienda) => {
      this._idAzienda = azienda?.id;
    });
    this.infoUtente = this._infoUtente.infoUtente?.utente;
  }

  public getListaFolders() {
    return this._webService.doGet(
      '/api/v1/documenti/user/' + this.infoUtente?.id + '/azienda/' + this._idAzienda + '/list',
      {},
    );
  }

  public deleteFolderById(idFolder: any) {
    return this._webService.doDelete(
      '/api/v1/documenti/user/' +
        this.infoUtente?.id +
        '/azienda/' +
        this._idAzienda +
        '/folder/id/' +
        idFolder +
        '/delete',
      {},
    );
  }
  public deleteFileById(idFile: any) {
    return this._webService.doDelete(
      '/api/v1/documenti/user/' +
        this.infoUtente?.id +
        '/azienda/' +
        this._idAzienda +
        '/file/id/' +
        idFile +
        '/delete',
      {},
    );
  }

  public createFolder(parentPath: string, nomeFolder: string) {
    return this._webService.doPost(
      '/api/v1/documenti/user/' +
        this.infoUtente?.id +
        '/azienda/' +
        this._idAzienda +
        '/folder/name/' +
        nomeFolder +
        '/create',
      { parentPath },
    );
  }

  public updateFolder(nomeFolder: string, idFolder: string) {
    return this._webService.doPost(
      '/api/v1/documenti/user/' +
        this.infoUtente?.id +
        '/azienda/' +
        this._idAzienda +
        '/folder/id/' +
        idFolder +
        '/name/' +
        nomeFolder +
        '/update',
      {},
    );
  }

  public getDownloadFile(idFile: string) {
    return this._webService.doGet(
      '/api/v1/documenti/user/' +
        this.infoUtente?.id +
        '/azienda/' +
        this._idAzienda +
        '/file/id/' +
        idFile +
        '/download',
      {},
      true,
      'blob',
    );
  }

  public updateFileName(nomeFile: string, idFile: string) {
    return this._webService.doPost(
      '/api/v1/documenti/user/' +
        this.infoUtente?.id +
        '/azienda/' +
        this._idAzienda +
        '/file/id/' +
        idFile +
        '/name/' +
        nomeFile +
        '/update',
      {},
    );
  }

  public getFoldersForModuli(idModulo: string | null) {
    return this._webService.doGet(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/report-vsme/utente/' +
        this.infoUtente?.id +
        '/associated' +
        '/folders',
      {
        idReportVsme: idModulo,
      },
    );
  }
}
